/**
 * Homeowner pages that used to share one Property Details screen.
 * Property Details is the house. Utility and Service Providers is the contact list.
 */

const PROPERTY_PATH = '/property';
const CONTACTS_PATH = '/contacts';

const HOMEOWNER_PAGE_LINKS = [
  { id: 'property', path: PROPERTY_PATH, label: 'Property Details' },
  { id: 'contacts', path: CONTACTS_PATH, label: 'Utility and Service Providers' },
];

function normalizePath(pathname) {
  const path = String(pathname || '').split('?')[0].split('#')[0].replace(/\/+$/, '');
  return path || '/';
}

function homeownerPageFromPath(pathname) {
  const path = normalizePath(pathname);
  if (path === PROPERTY_PATH || path === '/property-details') return 'property';
  if (path === CONTACTS_PATH || path === '/property-contacts') return 'contacts';
  return null;
}

function pathForHomeownerTab(tabId) {
  if (tabId === 'property') return PROPERTY_PATH;
  if (tabId === 'contacts') return CONTACTS_PATH;
  return null;
}

export {
  PROPERTY_PATH,
  CONTACTS_PATH,
  HOMEOWNER_PAGE_LINKS,
  homeownerPageFromPath,
  pathForHomeownerTab,
};
